/** Look of a filter dropdown that currently has a value selected: a light tint, not a highlight. */
export const activeFilterClass =
  "border-blue-300 bg-blue-50/60 hover:border-blue-400 hover:bg-blue-50/60";
